(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["repeating-sale-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('repeating-sale-bar')) {
    customElements.define('repeating-sale-bar', class extends HTMLElement {
      connectedCallback() {
        this.timeout = setTimeout(() => this.start(), 0);
      }

      disconnectedCallback() {
        clearTimeout(this.timeout);
      }

      start() {
        const { days, hours, minutes, anchor } = this.dataset;
        const duration = Math.max(60, Number(days) * 86400 + Number(hours) * 3600 + Number(minutes) * 60) * 1000;
        const hasTimeZone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(anchor);
        const parsedAnchor = hasTimeZone ? Date.parse(anchor) : NaN;
        const startAt = Number.isFinite(parsedAnchor) ? parsedAnchor : 0;
        const timer = this.querySelector('.rsb__timer');
        const digits = [...this.querySelectorAll('[data-unit]')];
        const showDays = digits.some((digit) => digit.dataset.unit === 'days');

        const tick = () => {
          const now = Date.now();
          const elapsed = ((now - startAt) % duration + duration) % duration;
          const remaining = Math.ceil((duration - elapsed) / 1000);
          const values = {
            days: Math.floor(remaining / 86400),
            hours: Math.floor(remaining / 3600) % (showDays ? 24 : Infinity),
            minutes: Math.floor(remaining / 60) % 60,
            seconds: remaining % 60
          };
          for (const digit of digits) {
            const value = String(values[digit.dataset.unit]).padStart(2, '0');
            if (digit.textContent !== value) digit.textContent = value;
          }
          timer.hidden = false;
          this.timeout = setTimeout(tick, 1000 - (elapsed % 1000));
        };

        tick();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
